import {observer} from 'mobx-react-lite'
import React, {useEffect, useState} from 'react'
import {useLoggedInStore} from '@components/logged-in/logged-in-store'
import {useSyncEvent} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {ChooseColorScheme} from './choose-color-scheme'
import {ChooseInterfaceLanguage} from './choose-interface-language'
import {Skin} from './skin'
import {
  SystemAppearanceContext,
  SystemAppearanceStore,
  useSystemAppearanceStore
} from './system-appearance-store'

export const SystemAppearance = () => {
  const [, loggedInStore] = useLoggedInStore()
  const [store] = useState(() => new SystemAppearanceStore(loggedInStore))

  return (
    <SystemAppearanceContext.Provider value={store}>
      <SystemAppearanceBase />
    </SystemAppearanceContext.Provider>
  )
}

const SystemAppearanceBase = observer(() => {
  const [, store] = useSystemAppearanceStore()

  useEffect(() => {
    store.calculateCustomSkins()
  }, [])

  useSyncEvent(
    'profile',
    {
      debounceTime: 50,
      filter: globals.currentUserId
    },
    () => {
      store.calculateCustomSkins()
    }
  )

  return (
    <>
      <div className="flex flex-wrap mb-24 gap-x-136 gap-y-24">
        <ChooseColorScheme />
        <ChooseInterfaceLanguage />
      </div>

      <Skin />
    </>
  )
})
